let loaded = false;

export function ensureIubendaScript() {
  if (loaded) return;
  loaded = true;
  const s = document.createElement('script');
  s.src = 'https://cdn.iubenda.com/iubenda.js';
  s.async = true;
  document.body.appendChild(s);
}
